export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  authorizationParams: {
    redirect_uri: window.location.origin,
    // Include API audience to get access tokens for backend API
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    // Request offline_access scope to get refresh tokens
    scope: 'openid profile email offline_access'
  },
  // Use refresh tokens for better UX
  useRefreshTokens: true,
  // Cache location for better performance
  cacheLocation: 'localstorage' as const,
  // Skip the silent check on initial load to reduce 400 errors
  skipRedirectCallback: false,
};
